<template>
  <div>
    <div style="overflow:hidden;">
      <div
        style="background-image:url(https://file.lgbfss.com/www/official/images/education/education1.jpg);height:713px"
      >
        <div class="content">
          <div class="container">
            <div
              class="font-color-1 font-size-76 text-align-center"
              style="padding-top:250px;padding-bottom:70px;"
            >破茧成蝶，高薪从此不漫长！</div>
            <div class="text-align-center">
              <span class="register-btn">线上注册 / 专业授课 / 线上测评 / 资质考核</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 教育内容 -->
    <div>
      <div class="content">
        <div class="container text-align-center">
          <div class="title font-color-2">教育内容</div>
          <div class="sub-title">Education content</div>
          <div style="margin-bottom:50px;">
            <span class="slider slider-orange"></span>
          </div>
          <p class="content font-size-18">零工教育是“全球云端”零工创客共享服务平台着力提升人才职业竞争力培养计划的一大模块。</p>
          <p class="content font-size-18">零工教育依托于互联网技术，一端开放给专业教育培训机构，一端开放给各行各业的在职人员或灵活就业人群，</p>
          <p
            class="content font-size-18"
          >通过线上注册、专业授课、线上测评、资质考核等流程，提升“创客们”的专业技能和服务能力，为企业提供专业化和高品质服务人才。</p>
          <img
            src="https://file.lgbfss.com/www/official/images/education/education2.jpg"
            alt
            class="image-center"
          />
        </div>
      </div>
    </div>
    <!-- 教育优势 -->
    <div style="overflow:hidden;">
      <div
        style="background-image:url(https://file.lgbfss.com/www/official/images/education/education7.jpg);height:778px"
      >
        <div class="content">
          <div class="container text-align-center">
            <div class="title font-color-1">教育优势</div>
            <div class="font-color-1 sub-title">Educational advantage</div>
            <div style="margin-bottom:50px;">
              <span class="slider slider-white"></span>
            </div>
            <div class="row">
              <div class="list-item">
                <span class="item-icon item-icon1"></span>
                <div>
                  <span class="split-line"></span>
                </div>
                <p class="p-title">政府授权，政策扶持</p>
              </div>
              <div class="list-item">
                <span class="item-icon item-icon2"></span>
                <div>
                  <span class="split-line"></span>
                </div>
                <p class="p-title">有口皆碑，至臻品质</p>
              </div>
              <div class="list-item">
                <span class="item-icon item-icon3"></span>
                <div>
                  <span class="split-line"></span>
                </div>
                <p class="p-title">政府授权，政策扶持</p>
              </div>
            </div>
            <div class="row">
              <div class="list-item">
                <span class="item-icon item-icon4"></span>
                <div>
                  <span class="split-line"></span>
                </div>
                <p class="p-title">专业讲师，教导有方</p>
              </div>
              <div class="list-item">
                <span class="item-icon item-icon5"></span>
                <div>
                  <span class="split-line"></span>
                </div>
                <p class="p-title">高尖科技，互联互通</p>
              </div>
              <div class="list-item">
                <span class="item-icon item-icon6"></span>
                <div>
                  <span class="split-line"></span>
                </div>
                <p class="p-title">全程追踪，效果放心</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 资质评定 -->
    <div>
      <div class="content">
        <div class="container">
          <div class="title font-color-2 text-align-center">资质评定</div>
          <div class="sub-title text-align-center">Qualification assessment</div>
          <div style="margin-bottom:50px;" class="text-align-center">
            <span class="slider slider-orange"></span>
          </div>
          <div class="row" style="flex-wrap: nowrap;align-items: center;">
            <img
              src="https://file.lgbfss.com/www/official/images/education/education3.jpg"
              alt
              style="flex-shrink:0;"
            />
            <div class="info">
              <p>
                参与培训学员个人在“全球云端”零工创客共享服务平台注册报名后，平台将根据
                学员个人的培训需求为其匹配相关专业课程，在学员学习过程中，零工创客共享服
                务平台将对学员的学习过程全程追踪记录，根据学员学习课程的完成率安排学员进
                行测评考核，通过考核的学员将被推荐给各有用工需求的企业。
              </p>
              <p>
                “全球云端”零工创客共享服务平台将根据创客们的履历经验、特长爱好提供相关
                的教育培训课程推荐。
              </p>
              <p>
                在学员学习过程中，零工创客共享服务平台将对学员的学习过程全程追踪记录，根
                据学员学习课程的完成率安排学员进行测评考核，通过考核的学员将被推荐给各有
                用工需求的企业。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 服务对象 -->
    <div style="overflow:hidden;">
      <div
        style="background-image:url(https://file.lgbfss.com/www/official/images/education/education7.jpg);height:778px"
      >
        <div class="content">
          <div class="container text-align-center">
            <div class="title font-color-1">服务对象</div>
            <div class="font-color-1 sub-title">Target Group</div>
            <div style="margin-bottom:50px;">
              <span class="slider slider-white"></span>
            </div>
            <div class="row">
              <div
                class="list-item1"
                style="background-image:url(https://file.lgbfss.com/www/official/images/education/education10.png);"
              >
                <div class="cover-layer">
                  <span class="item-icon item-icon7"></span>
                  <p class="p-title">在职人员</p>
                </div>
              </div>
              <div
                class="list-item1"
                style="background-image:url(https://file.lgbfss.com/www/official/images/education/education11.png);"
              >
                <div class="cover-layer">
                  <span class="item-icon item-icon8"></span>
                  <p class="p-title">企业员工</p>
                </div>
              </div>
              <div
                class="list-item1"
                style="background-image:url(https://file.lgbfss.com/www/official/images/education/education12.png);"
              >
                <div class="cover-layer">
                  <span class="item-icon item-icon9"></span>
                  <p class="p-title">自由职业者</p>
                </div>
              </div>
              <div
                class="list-item1"
                style="background-image:url(https://file.lgbfss.com/www/official/images/education/education13.png);"
              >
                <div class="cover-layer">
                  <span class="item-icon item-icon10"></span>
                  <p class="p-title">进阶创客</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 零工课程 -->
    <div style="overflow:hidden;">
      <div
        style="background-image:url(https://file.lgbfss.com/www/official/images/education/education9.jpg);height:854px"
      >
        <div class="content">
          <div class="container">
            <div class="title font-color-2 text-align-center">零工课程</div>
            <div class="sub-title text-align-center">Courses</div>
            <div style="margin-bottom:50px;" class="text-align-center">
              <span class="slider slider-orange"></span>
            </div>
            <div class="row" style="margin:0 -30px;">
              <div style="margin:5px;">
                <img src="https://file.lgbfss.com/www/official/images/education/education4.jpg" alt />
                <div class="sub-list">
                  <div class="row">
                    <span>方差标准差</span>
                    <span>7'10''</span>
                  </div>
                  <div class="row">
                    <span>统计量抽样分布</span>
                    <span>7'10''</span>
                  </div>
                  <div class="row">
                    <span>平均估计量标准</span>
                    <span>7'10''</span>
                  </div>
                  <div class="row">
                    <span>平均估计量标准</span>
                    <span>7'10''</span>
                  </div>
                </div>
              </div>
              <div>
                <div class="row">
                  <div class="list-item2">
                    <img
                      src="https://file.lgbfss.com/www/official/images/education/education5.jpg"
                      style="width:277px"
                      alt
                    />
                    <p class="p-title">信息素养：效率提升与终生学习</p>
                    <div class="row">
                      <span>讲师：王三金</span>
                      <span>人数：35人</span>
                    </div>
                  </div>
                  <div class="list-item2">
                    <img
                      src="https://file.lgbfss.com/www/official/images/education/education5.jpg"
                      style="width:277px"
                      alt
                    />
                    <p class="p-title">信息素养：效率提升与终生学习</p>
                    <div class="row">
                      <span>讲师：王三金</span>
                      <span>人数：35人</span>
                    </div>
                  </div>
                  <div class="list-item2">
                    <img
                      src="https://file.lgbfss.com/www/official/images/education/education5.jpg"
                      style="width:277px"
                      alt
                    />
                    <p class="p-title">信息素养：效率提升与终生学习</p>
                    <div class="row">
                      <span>讲师：王三金</span>
                      <span>人数：35人</span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="list-item2">
                    <img
                      src="https://file.lgbfss.com/www/official/images/education/education5.jpg"
                      style="width:277px"
                      alt
                    />
                    <p class="p-title">信息素养：效率提升与终生学习</p>
                    <div class="row">
                      <span>讲师：王三金</span>
                      <span>人数：35人</span>
                    </div>
                  </div>
                  <div class="list-item2">
                    <img
                      src="https://file.lgbfss.com/www/official/images/education/education5.jpg"
                      style="width:277px"
                      alt
                    />
                    <p class="p-title">信息素养：效率提升与终生学习</p>
                    <div class="row">
                      <span>讲师：王三金</span>
                      <span>人数：35人</span>
                    </div>
                  </div>
                  <div class="list-item2">
                    <img
                      src="https://file.lgbfss.com/www/official/images/education/education5.jpg"
                      style="width:277px"
                      alt
                    />
                    <p class="p-title">信息素养：效率提升与终生学习</p>
                    <div class="row">
                      <span>讲师：王三金</span>
                      <span>人数：35人</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Nav></Nav>
    <Footer></Footer>
  </div>
</template>

<script>
import Nav from "../components/nav";
import Footer from "../components/footer";
export default {
  name: "education",
  components: {
    Nav,
    Footer,
  },
};
</script>

<style lang="css" scoped>
.font-size-76 {
  font-size: 76px;
}
.text-align-center {
  text-align: center;
}
.register-btn {
  padding: 10px 40px;
  background-color: #fff;
  color: #444444;
  font-size: 35px;
  border-radius: 35px;
}
.title {
  font-size: 46px;
  font-weight: bold;
  padding: 58px 0 15px 0px;
}
.sub-title {
  font-size: 20px;
  color: #cbcbcb;
  font-family: Arial, Helvetica, sans-serif;
}
.content {
  color: #333333;
  padding: 5px 0;
}
.slider {
  display: inline-block;
  width: 80px;
  height: 3px;
}
.slider-orange {
  background-color: #f38303;
}
.slider-white {
  background-color: #ffffff;
}
.image-center {
  padding: 38px 0 58px 0;
}
.list-item {
  background-color: #ffffff;
  flex-grow: 1;
  margin: 6px;
  color: #333333;
  font-size: 20px;
  cursor: pointer;
  padding: 30px 0;
}
.list-item:hover {
  background-color: #64cdff;
  color: #ffffff;
}
.split-line {
  display: inline-block;
  width: 34px;
  height: 2px;
  background-color: #64cdff;
}
.list-item:hover .split-line {
  background-color: #ffffff;
}
.item-icon {
  display: inline-block;
  width: 100px;
  height: 100px;
}

.item-icon1 {
  background-image: url(https://file.lgbfss.com/www/official/images/education/icon1.png);
}
.item-icon2 {
  background-image: url(https://file.lgbfss.com/www/official/images/education/icon2.png);
}
.item-icon3 {
  background-image: url(https://file.lgbfss.com/www/official/images/education/icon3.png);
}
.item-icon4 {
  background-image: url(https://file.lgbfss.com/www/official/images/education/icon4.png);
}
.item-icon5 {
  background-image: url(https://file.lgbfss.com/www/official/images/education/icon5.png);
}
.item-icon6 {
  background-image: url(https://file.lgbfss.com/www/official/images/education/icon6.png);
}
.list-item:hover .item-icon1 {
  background-image: url(https://file.lgbfss.com/www/official/images/education/icon1-1.png);
}
.list-item:hover .item-icon2 {
  background-image: url(https://file.lgbfss.com/www/official/images/education/icon2-1.png);
}
.list-item:hover .item-icon3 {
  background-image: url(https://file.lgbfss.com/www/official/images/education/icon3-1.png);
}
.list-item:hover .item-icon4 {
  background-image: url(https://file.lgbfss.com/www/official/images/education/icon4-1.png);
}
.list-item:hover .item-icon5 {
  background-image: url(https://file.lgbfss.com/www/official/images/education/icon5-1.png);
}
.list-item:hover .item-icon6 {
  background-image: url(https://file.lgbfss.com/www/official/images/education/icon6-1.png);
}
.item-icon7 {
  background-image: url(https://file.lgbfss.com/www/official/images/education/icon7-1.png);
}
.item-icon8 {
  background-image: url(https://file.lgbfss.com/www/official/images/education/icon8-1.png);
}
.item-icon9 {
  background-image: url(https://file.lgbfss.com/www/official/images/education/icon9-1.png);
}
.item-icon10 {
  background-image: url(https://file.lgbfss.com/www/official/images/education/icon10-1.png);
}
.cover-layer:hover .item-icon7 {
  background-image: url(https://file.lgbfss.com/www/official/images/education/icon7.png);
}
.cover-layer:hover .item-icon8 {
  background-image: url(https://file.lgbfss.com/www/official/images/education/icon8.png);
}
.cover-layer:hover .item-icon9 {
  background-image: url(https://file.lgbfss.com/www/official/images/education/icon9.png);
}
.cover-layer:hover .item-icon10 {
  background-image: url(https://file.lgbfss.com/www/official/images/education/icon10.png);
}
.info {
  flex-grow: 1;
  padding: 20px 30px;
  box-shadow: 0 0 10px 2px #dbdbdb;
}
.info p {
  font-size: 16px;
  color: #666666;
  line-height: 32px;
  margin-bottom: 50px;
}
.info p:last-child {
  margin-bottom: 0;
}

.list-item1 {
  background-color: #ffffff;
  flex-grow: 1;
  margin: 6px;
  color: #333333;
  font-size: 20px;
  height: 314px;
}
.cover-layer {
  width: 100%;
  height: 100%;
  background-color: #434343;
  opacity: 0.8;
  cursor: pointer;
  color: #ffffff;
}
.cover-layer:hover {
  background-color: #a0dbf5;
  color: #3c4f5b;
}
.cover-layer .item-icon {
  margin-top: 60px;
}
.cover-layer p.p-title {
  margin-top: 35px;
}
.sub-list {
  border: 1px solid #dcdcdc;
  border-top: none;
  padding: 12px 15px;
}
.sub-list div.row {
  line-height: 30px;
}
.sub-list div.row span {
  font-size: 14px;
}
.sub-list div.row span:first-child {
  color: #444444;
}
.sub-list div.row span:last-child {
  color: #d0d0d0;
}
.list-item2 {
  border: 1px solid #dcdcdc;
  margin: 6px;
  cursor: pointer;
}
.list-item2:hover {
  box-shadow: 0 0 12px 5px #dcdcdc;
}
.list-item2 p {
  border-bottom: 1px solid #dcdcdc;
  padding: 0 15px;
  font-size: 14px;
  color: #444444;
  line-height: 40px;
}
.list-item2 div.row {
  justify-content: space-between;
  padding: 0 15px;
}
.list-item2 span {
  font-size: 14px;
  color: #999999;
  line-height: 32px;
}
</style>
